import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';
import { Badge } from 'primereact/badge';
import { Tooltip } from 'primereact/tooltip';

export default function MenuReduzido() {
    const itemRenderer = (item, options) => (
        <a
            className="flex align-items-center px-3 py-2 cursor-pointer gap-2"
            onClick={(e) => {
                e.preventDefault();
                options.onClick(e);
            }}
        >
            {/* Adicionando Tooltip diretamente no ícone */}
            <span className={`${item.icon} text-secondary`} data-pr-tooltip={item.shortcut} />
            
            <span className={`mx-2 ${item.items ? 'font-semibold menu-oculto' : 'menu-oculto'}`}>{item.label}</span>

        </a>
    );

    const items = [
        {
            label: 'Dashboard',
            icon: 'pi pi-chart-scatter',
            badge: 5,
            template: itemRenderer,           
        },
        {
            label: 'Empresas',
            icon: 'pi pi-warehouse',
            badge: 5,
            template: itemRenderer,           
        },
        {
            label: 'Usuários',
            icon: 'pi pi-users',
            badge: 5,
            template: itemRenderer,           
        },
        {
            label: 'Clientes',
            icon: 'pi pi-address-book',
            shortcut: '⌘+R',
            template: itemRenderer,
            items: [
                { label: 'Sales', icon: 'pi pi-plus', badge: 3, template: itemRenderer },
                { label: 'Products', icon: 'pi pi-arrow-up', badge: 6, template: itemRenderer }
            ]
        },
        {
            label: 'Collector',
            icon: 'pi pi-sitemap',
            shortcut: '⌘+W',
            template: itemRenderer,
            items: [
                { label: 'Licenças', icon: 'pi pi-key', shortcut: '⌘+O', template: itemRenderer },
                { label: 'DCAs', icon: 'pi pi-share-alt', shortcut: '⌘+P', template: itemRenderer }
            ]
        }
    ];

    return (
        <div className="card flex justify-content-center" id='menu-reduzido'>
            {/* Não é mais necessário adicionar o Tooltip globalmente */}
            <PanelMenu model={items} className="w-full md:w-20rem " />
        </div>
    );
}
